import { useCallback } from "react";
import { useSearchParams } from "react-router";
import { DONATE_PARAM } from "../../app/routes";

/**
 * Whether the donate panel is open is part of the URL (?donate), so it has one owner, it
 * can be linked to, and the Back button closes it.
 */
export function useDonatePanel() {
  const [params, setParams] = useSearchParams();
  const isOpen = params.has(DONATE_PARAM);

  const open = useCallback(() => {
    setParams((current) => {
      const next = new URLSearchParams(current);
      next.set(DONATE_PARAM, "");
      return next;
    });
  }, [setParams]);

  const close = useCallback(() => {
    setParams(
      (current) => {
        const next = new URLSearchParams(current);
        next.delete(DONATE_PARAM);
        return next;
      },
      { replace: true },
    );
  }, [setParams]);

  return { isOpen, open, close };
}
